import React from 'react';
import { LoadingOverlay as Overlay } from '../../../loading-overlay';
import styled from 'styled-components';
const StyledOverlay = styled(Overlay) `
  width: 100%;
  height: 100%;
`;
export const LoadingOverlay = () => {
    return (React.createElement("div", null,
        React.createElement(StyledOverlay, { text: "Loading..." })));
};
